var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSurvey = function SvgSurvey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M9 6a1 1 0 0 1 1-1h13.92a1 1 0 0 1 .7.3l7.09 7.07a1 1 0 0 1 .29.71v21.59a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.33 5 32 12.67h-6.67a1 1 0 0 1-1-1V5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m24.33 5 .7-.7a1 1 0 0 0-1.7.7h1ZM32 12.67v1a1 1 0 0 0 .7-1.71l-.7.7Zm0-1h-6.67v2H32v-2Zm-6.67 0V5h-2v6.67h2Zm-1.7-5.96 7.66 7.66 1.42-1.41-7.67-7.67-1.42 1.42Zm1.7 5.96h-2c0 1.1.9 2 2 2v-2Z"
  })));
};
export default SvgSurvey;